import Box from 'UIKit/Box/Box'
import { BoxProps } from 'UIKit/Box/types'
import Tab, { TabProps } from 'UIKit/Tab'
import Tabs from 'UIKit/Tabs'
import Text from 'UIKit/Text'
import { ALL_GAME_TAG } from 'config/constants/gameTags'
import useGameTag from 'hooks/useGameTag'
import { useMemo } from 'react'
import { Trans } from 'react-i18next'
import styled from 'styled-components'
import { colors } from 'theme/colors'

const StyledTabContainer = styled(Tab)<{ $active: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 12px;
  box-sizing: border-box;
  align-items: center;
  justify-content: center;

  ${Text} {
    transition: ${({ theme }) => theme.transitions.fast};
    color: ${({ theme, $active }) => ($active ? `${theme.colors.text}` : theme.colors.textSubtle)};
    white-space: pre !important;
  }

  &:hover,
  &:focus-visible {
    ${Text} {
      color: ${({ theme }) => theme.colors.text};
      white-space: pre !important;
    }
  }
`

const StyledIndicator = styled.div`
  border-radius: ${({ theme }) => theme.radii.small};
  background: rgba(255, 255, 255, 0.04);
  height: 100%;
  width: 100%;
`

type GameSubTagProps = {
  onTagChanged: (value: string) => void
  value: string
  backgroundBlurColor?: string
  tags: string[]
}

const GameSubTag: React.FC<GameSubTagProps & BoxProps> = ({
  onTagChanged,
  value,
  backgroundBlurColor,
  tags,
  ...props
}) => {
  const parseTags = useMemo(() => [ALL_GAME_TAG, ...tags.filter((tag) => tag !== ALL_GAME_TAG)], [tags])
  return (
    <Box {...props} maxWidth={['calc(100% - 72px)', '', 'calc(100% - 150px)']}>
      <Tabs
        value={value}
        onTagChanged={onTagChanged}
        backgroundBlurColor={backgroundBlurColor || colors.background}
        indicator={<StyledIndicator />}
      >
        {parseTags.map((tag) => (
          <SubTab key={`sub-tag-${tag}`} tagCode={tag} value={tag} selectedValue={value} />
        ))}
      </Tabs>
    </Box>
  )
}

const SubTab: React.FC<{ tagCode: string; selectedValue: string } & TabProps> = ({
  tagCode,
  selectedValue,
  ...props
}) => {
  const tag = useGameTag(tagCode)
  return (
    <StyledTabContainer $active={selectedValue === tag?.value} {...props}>
      <Text bold fontSize={['12px', '12px', '14px']}>
        <Trans>{tag?.value === ALL_GAME_TAG ? 'All' : tag?.content}</Trans>
      </Text>
    </StyledTabContainer>
  )
}

export default GameSubTag
